// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"353":"contact","574":"footer","594":"about","597":"projects","859":"experience"}[chunkId] + "." + {"353":"18ce893b","574":"9882f1fa","594":"6508c234","597":"bb7ced13","859":"018ae240"}[chunkId] + ".chunk.css";
};